<!-- App.svelte -->
<script>
  import { Router, Route } from "svelte-routing";

  import en from './locales/en.json';
  import gr from './locales/gr.json';
  import hr from './locales/hr.json';
  import it from './locales/it.json';

  import { addMessages, init } from 'svelte-i18n';

  import { api } from "./libs/api.js";
  import { config } from './libs/config.js';

  import Index from "./pages/Index.svelte";
  import Login from "./pages/Login.svelte";
  import Profile from "./pages/Profile.svelte";
  import Credits from "./pages/Credits.svelte";
  import Feedback from "./pages/Feedback.svelte";
  import Backpack from "./pages/Backpack.svelte";
  import ShowTrail from "./pages/ShowTrail.svelte";
  import NavigateTrail from "./pages/NavigateTrail.svelte";
  import ShowAllTrails from "./pages/ShowAllTrails.svelte";
  import ShowExcursion from "./pages/ShowExcursion.svelte";
  import ShowAllMyExcursions from "./pages/ShowAllMyExcursions.svelte";

  export let url = "";

  api.refresh_token();

  addMessages('en', en);
  addMessages('gr', gr);
  addMessages('hr', hr);
  addMessages('it', it);

  init({
    fallbackLocale: 'en',
    initialLocale: config.language,
  });
</script>

<Router url="{url}">
  <Route path="credits" component="{Credits}" />
  <Route path="navigate/:id" component="{NavigateTrail}" />
  <Route path="excursions/:id/feedback" component="{Feedback}" />
  <Route path="excursions/:id/backpack" component="{Backpack}" />
  <Route path="excursions/:id" component="{ShowExcursion}" />
  <Route path="excursions" component="{ShowAllMyExcursions}" />
	<Route path="trails/:id" component="{ShowTrail}" />
	<Route path="trails" component="{ShowAllTrails}" />
  <Route path="profile" component="{Profile}" />
  <Route path="login" component="{Login}" />
	<Route path="/" component="{Index}" />
</Router>